import React, { useState } from 'react'
import moment from 'moment'
import styled from 'styled-components'

import { downloadFuzzyQuestionAnswerLogs } from './utils'
import { useIsFuzzyQuestionAnswersModeOn } from './hooks'
import { alert } from '../../../../../../../../lib/bootbox'
import { useBotId } from '../../../../../../../../store/flow'
import { Button, ButtonType } from '../../../../../../../Styleguide/Button'
import { DateTimeRangePickerPopup } from '../../../../../../../modals/DateTimeRangePickerPopup'

export const FuzzyQuestionAnswerLogsDownloadButton: React.FC = () => {
  const botId = useBotId()
  const isFuzzyQuestionAnswersModeOn = useIsFuzzyQuestionAnswersModeOn()
  const [isFileDownloading, setIsFileDownloading] = useState<boolean>(false)
  const [showDateTimeRangePicker, setShowDateTimeRangePicker] = useState<boolean>(false)

  if (!isFuzzyQuestionAnswersModeOn) {
    return null
  }

  return (
    <>
      {showDateTimeRangePicker && (
        <DateTimeRangePickerPopup
          onClose={() => setShowDateTimeRangePicker(false)}
          onConfirm={async (dateFrom, dateTo) => {
            if (!dateFrom) {
              return alert({
                title: '❌ Invalid date from',
                message:
                  'We are sorry, but without picked valid date from cannot download fuzzy question answer logs.'
              })
            }

            const fromTimestamp = moment(Date.parse(dateFrom)).unix()
            const toTimestamp = moment(dateTo ? Date.parse(dateTo) : Date.now()).unix()
            if (fromTimestamp >= toTimestamp) {
              return alert({
                title: '❌ Invalid date from and date to',
                message:
                  'We are sorry, but without range where date from is sooner than date to cannot download fuzzy question answer logs.'
              })
            }

            await downloadFuzzyQuestionAnswerLogs(
              botId,
              fromTimestamp,
              toTimestamp,
              setIsFileDownloading
            )
            setShowDateTimeRangePicker(false)
          }}
        />
      )}
      <StyledButton
        text="Download fuzzy answer logs"
        disabled={isFileDownloading}
        isLoading={isFileDownloading}
        buttonType={ButtonType.DEFAULT}
        onClickWhenDisabled={e => e.preventDefault()}
        onClick={event => {
          event.preventDefault()
          setShowDateTimeRangePicker(true)
        }}
      />
    </>
  )
}

const StyledButton = styled(Button)`
  margin-left: 10px;
`
